import nike from "../../Assets/Brand Image/nike.png"
import adidas from "../../Assets/Brand Image/adidas.png"
import ck from "../../Assets/Brand Image/ck.jpg"
import dg from "../../Assets/Brand Image/d&gg.png"
import gucci from "../../Assets/Brand Image/Gucci.png"

const brands = [
    {
        id: 1,
        name: "Nike",
        image: nike
        
    },
    {
        id: 2,
        name: "Adidas",
        image: adidas
    },
    {
        id: 3,
        name: "Calvin klein",
        image: ck
    },
    {
        id: 4,
        name: "Dolce & Gabbana",
        image: dg
    },
    {
        id: 5,
        name: "Gucci",
        image: gucci
    },
]
export default brands